import { call, put } from "redux-saga/effects";

import { api, notify } from "services";
import { ICreateRequest } from "interfaces/create-duck";
import { requestErrorHandler } from "utils";
import { CreatePickingFileActions } from "store/ducks/picking-files";

export function* createPickingFileRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;

    const { data: responseBody } = yield call(
      api.post,
      `/picking-files`,
      postData
    );

    const { data } = responseBody;
    yield put(CreatePickingFileActions.success(data));
    notify("success", "Documento enviado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(CreatePickingFileActions.failure(errorMessage));
  }
}